import React from 'react';
import { DefaultInput } from './StyledInput';

export const LoginInput = React.forwardRef((props, ref) => (
  // eslint-disable-next-line react/jsx-props-no-spreading
  <DefaultInput placeholder="Користувач" {...props} ref={ref} />
));

export default LoginInput;
